import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const NavigationTile = ({ title, description, icon, path, count, badge }) => {
  return (
    <Link 
      to={path}
      className="group bg-card border border-border rounded-xl p-4 md:p-6 transition-smooth hover-lift hover:border-primary/50 active-press"
    >
      <div className="flex items-start gap-4">
        <div className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 bg-primary/10 rounded-lg transition-smooth group-hover:bg-primary/20 flex-shrink-0">
          <Icon name={icon} size={24} color="var(--color-primary)" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h3 className="text-base md:text-lg font-semibold text-foreground truncate">{title}</h3>
            {badge && (
              <span className="px-2 py-0.5 text-xs font-medium bg-accent/10 text-accent rounded-full whitespace-nowrap">
                {badge}
              </span>
            )}
          </div>
          <p className="text-sm text-muted-foreground line-clamp-2 mb-2">{description}</p>
          {count !== undefined && (
            <div className="flex items-center gap-1">
              <span className="text-xs text-muted-foreground">Toplam:</span>
              <span className="text-sm font-semibold text-foreground data-text">{count}</span>
            </div>
          )}
        </div>
        <Icon 
          name="ChevronRight" 
          size={20} 
          color="var(--color-muted-foreground)" 
          className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-smooth"
        />
      </div>
    </Link>
  );
};

export default NavigationTile;